import { render, staticRenderFns } from "./verlinkungen-editor.vue?vue&type=template&id=1c484e02&scoped=true"
import script from "./verlinkungen-editor.vue?vue&type=script&lang=js"
export * from "./verlinkungen-editor.vue?vue&type=script&lang=js"
import style0 from "./verlinkungen-editor.vue?vue&type=style&index=0&id=1c484e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c484e02",
  null
  
)

export default component.exports